/**
 * Channel Constants
 */

import type { ChannelDefinition } from "@interfaces/chat.interface";

export const CHANNEL_DEFINITIONS: ChannelDefinition[] = [
  { id: "zalo", label: "Zalo", icon: "icon-zalo" },
  { id: "facebook", label: "Facebook", icon: "message" },
  { id: "shopee", label: "Shopee", icon: "shopping" },
];
